<template>
	<div>
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>远程预付费</el-breadcrumb-item>
			<el-breadcrumb-item>远程拉合闸</el-breadcrumb-item>
		</el-breadcrumb>


		<!-- 搜索筛选 -->
		<el-form :inline="true" :model="formInline" class="user-search" ref='searchbox' @submit.native.prevent>
			<el-form-item label="搜索：">
				<el-input placeholder="请输入房间编号"  @keyup.enter.native="search"  v-model="formInline.meterPointName" size="small"></el-input>
			</el-form-item>



			<el-form-item>
				<el-input placeholder="请输入用户账号"  @keyup.enter.native="search"  v-model="formInline.username" size="small"></el-input>
			</el-form-item>
			<el-form-item v-if="user.username == 'admin'">
				<!-- <el-popover v-model="visible">
					<el-input ref="deptInput" readonly slot="reference" style="width: 260px;" size="small" value="" placeholder="选择部门/集中器" v-model="getJZ"  ></el-input>
					<div>
						<el-tree v-loading="treeLoad" :data="treeDate" :expand-on-click-node="false" :highlight-current="true" @node-click="handleNodeClick"
						 :props="jzProps" accordion node-key='id'>
							<span class="custom-tree-node" slot-scope="{ node, data }">
								<span>
									<i v-if="!data.parentId && !data.isJz" class="el-icon-office-building"></i>
									<i v-if="data.parentId" class="el-icon-location-outline"></i>
									<i v-if="data.isJz" class="el-icon-coin"></i>
									{{ data.departmentName }}
								</span>
							</span>

						</el-tree>
					</div>
				</el-popover> -->
        <el-select v-model="getJZ" placeholder="请选择" @change="handleNodeClick" size="small">
           <el-option
             v-for="item in treeDate"
             :key="item.id"
             :label="item.departmentName"
             :value="item.id">
           </el-option>
         </el-select>

			</el-form-item>
			<el-form-item>
				<el-select size="small" v-model="formInline.isRunning" placeholder="选择状态"  @keyup.enter.native="search" >
					<el-option v-for="type in runStatus" :label="type.lable" :value="type.value" :key="type.value"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
				<el-button size="small" type="success"  icon="el-icon-download" :loading="downloadLoadin" @click="exportdata">导出</el-button>
			</el-form-item>
		</el-form>

		<!-- 数据列表 -->
		<el-table :header-cell-style="this.$store.state.headerCss" size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
		 style="width: 100%;" ref="tablelist" :height="tableHeight" :row-class-name="tableRowClassName" stripe>
			<el-table-column align="center" type="index" width="60">
			</el-table-column>
			<!-- <el-table-column prop="id" align="center" label="id" width="100">
			</el-table-column> -->
			<el-table-column prop="meterPointName" label="房间编号" >
			</el-table-column>
			<!-- <el-table-column prop="meterPoint" label="计量点地址" show-overflow-tooltip width="200">
			</el-table-column> -->
			<el-table-column label="用户账号" show-overflow-tooltip>
				<template slot-scope="scope">

					<el-tag size="small" style="margin-right: 10px;"  v-if="scope.row.appletUserVo" v-bind:key="item.id"  v-for="item in scope.row.appletUserVo">{{item.username}}</el-tag>

				</template>
			</el-table-column>
			<el-table-column prop="blance" label="余额" >
			</el-table-column>
			<el-table-column  label="状态" width="120">
				<template slot-scope="scope">
					<el-tag size="mini" type="success" v-if="scope.row.isRunning">合闸</el-tag>
					<el-tag size="mini" type="info" v-if="!scope.row.isRunning">断开</el-tag>
				</template>
			</el-table-column>
			<el-table-column align="center" label="操作" width="360">
				<template slot-scope="scope">

					<el-button  size="mini" icon="el-icon-refresh" :loading="loadStatus && currid == scope.row.id"    @click="getStatus(scope.$index, scope.row)">刷新状态</el-button>
					<prems-button size="mini" type="danger"   perms="room:lz" @click="handleLz(scope.$index, scope.row,1)" label="拉闸" />
					<prems-button size="mini" type="success"   perms="room:lz" @click="handleLz(scope.$index, scope.row,2)" label="合闸" />
					<!-- <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button> -->
					<!-- <el-button size="mini" type="danger" @click="deleteInfo(scope.$index, scope.row)">删除</el-button> -->
				</template>
			</el-table-column>
		</el-table>
		<!-- <div style="line-height: 50px; font-size: 14px;color: #606266;">共：{{ listData.length }}条数据</div> -->
		<!-- 分页组件 -->
		<Pagination v-bind:child-msg="pageparm" @callFather="callFather" v-if="showPage" ></Pagination>

	</div>
</template>

<script>
	import Pagination from '../../components/Pagination'
	import PremsButton from "@/views/permission/PreButtom";
	import {
		findAllMeterInfoList,
		recharge,
		remoteDisconnect,
		refund
	} from '../../api/payMG.js'


	import { getDepartmentTerminalInfoLis,findMeterInfoList,getTerminalInfoByDepId,getMeterInfoStatus,findAppletUserMoneyPoiFiter } from '../../api/energyMG'
	export default {
		data() {

			return {
				downloadLoadin:false,
				showPage:true,
				searchData: {},
				getJZ: "",
				treeLoad: false,
				listData: [],
				users:[],
				loading: false,
				tableHeight: 0,

				currid:'',
				loadLz:false,


				runStatus:[
					{value:'',lable:'全部'},
					{value:'1',lable:'合闸'},
					{value:'0',lable:'断开'},
				],
				//查询参数
				formInline:{
					terIds:JSON.stringify([]),
					meterPoint:'',
					isRunning:'',
					meterPointName:'',
					energyType:15,
					currentPage: 1,
					pageSize: 20,
					username:"",
           sort:"id",
				},
				// 分页参数
				pageparm: {
					currentPage: 1,
					pageSize: 20,
					total: 0
				},
				appletUserid:'',
				editFormVisible: false,
				visible:false,
				saveLoad:false,
				title: "充值",
				loadStatus:false,
        user:{},

				jzProps:{
					label: function( data,node ){
						//console.log(data)
					},
					children: 'deps',

				},
				treeDate:[],


			}
		},
		created() {

			this.getJzData()
      this.user = JSON.parse(sessionStorage.getItem('userdata'))
      this.getJZ = this.user.departmentName
      console.log(this.user )


		},
		mounted() {

			this.getHeight()
		},
		methods: {
			exportdata(){
				this.downloadLoadin = true
				// let param =  {...this.exportParam,meterPointName:this.formInline.meterPointName}

				let param = {
					terIds:this.formInline.terIds,
					meterPoint:this.formInline.meterPoint,
					isRunning:this.formInline.isRunning,
					meterPointName:this.formInline.meterPointName,
					energyType:this.formInline.energyType,
					username:this.formInline.username
				}

				findAppletUserMoneyPoiFiter(param).then(res => {

					var blob = new Blob([res], {type: 'application/vnd.openxmlformats-  officedocument.spreadsheetml.sheet;charset=utf-8'}); //type这里表示xlsx类型
					var downloadElement = document.createElement('a');
				　　var href = window.URL.createObjectURL(blob); //创建下载的链接
				　　downloadElement.href = href;
				　　downloadElement.download = 'result.xls'; //下载后文件名
				　　document.body.appendChild(downloadElement);
				　　downloadElement.click(); //点击下载
				　　document.body.removeChild(downloadElement); //下载完成移除元素
				　　window.URL.revokeObjectURL(href); //释放掉blob对象
					this.downloadLoadin = false
					this.$message.success('表格生成成功！正在下载')
				}).catch(err => {
					this.downloadLoadin = false
					this.$message({
						message:'下载失败！',
						type:'error',
						showClose:true
					})
				})

			},
			search() {
				this.formInline.currentPage = 1
				this.pageparm.currentPage = 1

				this.getdata()
				this.showPage  =  false;

				this.$nextTick(() => {
					this.showPage = true
				})
			},
			tableRowClassName({row, rowIndex}){
				if(row.blance<=0){
					return 'warning-row'
				}
				return ''
			},

			//获取集中器信息
			getJzData:function(){
				return new Promise((resolve,reject) => {
					getDepartmentTerminalInfoLis().then(res => {
						this.treeLoad = false
						if(res.status == 1){
							let arr = []
							this.treeDate = res.data.menuDepList
							this.getDepIds(this.user.departmentId)
							resolve(res.data.terIds)
						}
						else{
							this.$message.error(res.msg)
						}
					})
				})

			},
			changeData( data ){
				data.forEach(item =>{
					if( item.terminalInfo){
						if(!item.deps){
							item.deps = []
						}
						item.terminalInfo.forEach(sitem => {
							let obj = {}
							obj.id = sitem.id
							obj.departmentName = sitem.terminalName
							obj.terminalCode = sitem.terminalCode
							obj.isJz= true
							item.deps.push(obj)
						})
					}
					if( item.deps){
						this.changeData(item.deps)
					}
				})

				return  data
			},
			handleNodeClick(data) {
				this.getDepIds(data)

			},

      getDepIds(id){
        getTerminalInfoByDepId({
        	depId: id
        }).then(res => {

        	if (res.status == 1) {
        		let arr = []
        		res.data.forEach(item => {
        			let obj = {}
        			obj.id = item
        			arr.push(obj)
        		})
        		this.formInline.terIds = JSON.stringify(arr)
            this.search()
        	} else {
        		this.$message.error(res.msg)
        	}

        })
      },


			handleEdit(index, row,type) {
				this.editFormVisible = true
				this.editFormVisible = true
				this.title = type == "1"?'充值':'退款'
				this.editForm.mark = ''
				if (row != undefined && row != 'undefined') {
					this.editForm.meterPointName = row.meterPointName
					this.users = row.appletUserVo || []
					this.editForm.appletUserid = row.appletUserVo[0].id
					this.editForm.blance = row.blance
					this.editForm.id = row.id
					this.totalFee = ""
				}
				console.log( typeof this.editForm.appletUserid)
			},
			// 关闭编辑、增加弹出框
			closeDialog() {
				this.editFormVisible = false
			},

			getHeight() {
				this.$nextTick(() => {
					let out = this.$refs.tablelist.$el.offsetTop + this.$refs.searchbox.$el.offsetTop
					this.tableHeight = window.innerHeight - out - 100
				})
			},




			// 分页插件事件
			callFather(parm) {
				this.formInline.currentPage = parm.currentPage
				this.formInline.pageSize = parm.pageSize
				this.getdata()
			},





			getdata() {
				this.loading = true

				findMeterInfoList(this.formInline).then(res => {
						this.loading = false
						if (res.status == 1) {
							this.listData = res.data.data
							this.pageparm.currentPage = this.formInline.currentPage
							this.pageparm.pageSize = this.formInline.pageSize
							this.pageparm.total = res.data.totalCount
							this.getHeight()
						} else {
							this.$message({
								type: 'info',
								message: res.msg
							})
						}
					})
					.catch(err => {
						this.loading = false

						this.$message.error('获取数据失败，请稍后再试！')
					})
			},
			add() {

				roomAdd(this.editForm)
					.then(res => {
						this.editFormVisible = false
						this.loading = false
						if (res.status == 1) {
							this.getdata()
							this.$message({
								type: 'success',
								message: '添加成功！'
							})
						} else {
							this.$message({
								type: 'info',
								message: res.msg
							})
						}
					})
					.catch(err => {
						this.editFormVisible = false
						this.loading = false
						this.$message.error('添加失败，请稍后再试！')
					})
			},
			update() {
				this.editForm.address = this.addressStr + this.editForm.street + this.editForm.roomNo
				roomUpdate(this.editForm)
					.then(res => {
						this.editFormVisible = false
						this.loading = false
						if (res.status == 1) {
							this.getdata()
							this.$message({
								type: 'success',
								message: '操作成功！'
							})
						} else {
							this.$message({
								type: 'info',
								message: res.msg
							})
						}
					})
					.catch(err => {
						this.editFormVisible = false
						this.loading = false
						this.$message.error('操作失败，请稍后再试！')
					})
			},
			// 删除
			deleteInfo(index, row) {
				this.$confirm('确定要删除吗?', '信息', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						roomDelete({
								roomId: row.id
							})
							.then(res => {
								if (res.status == 1) {
									this.$message({
										type: 'success',
										message: '已删除!'
									})
									this.getdata(this.formInline)
								} else {
									this.$message({
										type: 'info',
										message: res.msg
									})
								}
							})
							.catch(err => {
								this.loading = false
								this.$message.error('删除失败，请稍后再试！')
							})
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						})
					})
			},

			//拉闸
			handleLz(index,row,type){
				let typeStr =  type == 1?' 拉闸 ':' 合闸 '
				let cmsg = '确定对'+row.meterPointName+'进行'+ typeStr +'操作'

				this.$confirm(cmsg, '信息', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then( () =>{
						let param = {
							id:row.id,
							operType:type
						}
						this.currid = row.id
						this.loading = true
						this.loadLz = true
						remoteDisconnect(param).then(res => {
							this.loading = false
							this.loadLz = false
							if (res.status == 1) {
								this.$message({
									type: 'success',
									message: typeStr+'指令下发成功!请稍后刷新状态',
									duration:5000,
									showClose:true
								})
								this.getdata(this.formInline)
							} else {
								this.$message({
									type: 'info',
									message: res.msg
								})
							}
						})
						.catch(err => {
							this.loadLz = false
							this.$message.error('操作失败，请稍后再试！')
						})

					})
					.catch(err => {
							this.loadLz = false
							this.$message.info('取消操作！')
						})
			},
			//获取最新拉合闸状态
			getStatus(index,row){
				console.log(index)
				this.loadStatus = true
				this.currid = row.id
				getMeterInfoStatus({id:row.id}).then(res => {
					this.loadStatus = false
					console.log(res)
					if( res.status == 1 ){
						this.listData[index].isRunning = res.data
					}else{
						this.$message.error('获取状态失败，请稍后再试！')
					}
				})
			}

		},
		components: {
			Pagination,
			PremsButton
		},
	}
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/views/prepayment/room.vue